/* RESPONSIBLE TEAM: team-proactive-support */
import { belongsTo } from '@ember-data/model';
import RulesetLink from '../ruleset-link';
import { objectTypes } from 'embercom/models/data/matching-system/matching-constants';

export default RulesetLink.extend({
  object: belongsTo('tooltip-group', { async: false }),
  objectType: objectTypes.tooltipGroup,
});
